import React from 'react'



export const TRIGGER_ACTIONS = {
    time: 'time',
    slideApply: 'slideApply',
    backFromSettings: 'backFromSettings',
    backFromPreview: 'backFromPreview',
    settingsChanged: 'settingsChanged',
    templateApply: 'templateApply',
};

const MIN_IN_MS = 60000;

const APP_NAME_STORAGE = `text-slider`

const FIRST_TIME_DELAY_NOT_NOW = MIN_IN_MS * 30;

const DELAY_STEP_NOT_NOW = 15;

const TIME_LIMIT_FIRST_SHOW = MIN_IN_MS * 15;
// const TIME_LIMIT_FIRST_SHOW = MIN_IN_MS * 15;

const TICK_RATE = 500;

const TRIGGER_SEQUENCES = [
    [TRIGGER_ACTIONS.backFromPreview],
    [TRIGGER_ACTIONS.time, TRIGGER_ACTIONS.settingsChanged, TRIGGER_ACTIONS.backFromSettings],
    [TRIGGER_ACTIONS.slideApply, TRIGGER_ACTIONS.time],
    [TRIGGER_ACTIONS.templateApply]
];

const getCurrentTriggerActions = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            const triggerArray = storage.triggers;

            return triggerArray;
        } else {
            return [];
        }

    } catch (e) {
        console.error(`Can't get access to localStorage or storage.triggers is not an array`);
    }
}

const actionTriggered = () => {
    localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered`, `triggered`);
}


const isActionTriggered = () => {
    return localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered`) === 'triggered';
}

const clearActionTrigger = () => {
    localStorage.removeItem(`${APP_NAME_STORAGE}-rate-us-triggered`)
}


export const addRateUsTriggerTimeDelay = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            let minutesWas = storage.timeDelay / MIN_IN_MS
            if (minutesWas == 30 || minutesWas == 45) {
                storage.timeDelay = (minutesWas + DELAY_STEP_NOT_NOW) * MIN_IN_MS;
            } else if (storage.timeDelay != undefined && storage.timeDelay != null) {
                storage.timeDelay = MIN_IN_MS * 60;
            } else {
                storage.timeDelay = MIN_IN_MS * 30;
            }

            storage.lastTimeNotNow = Date.now();

            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
        } else {
            let storage = {
                timeDelay: FIRST_TIME_DELAY_NOT_NOW,
                lastTimeNotNow: Date.now()
            }

            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));

        }
    } catch (e) {
        console.error(`Can't get access to localStorage`);
    }
}

export const setNeverAgain = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            storage.neverAgain = true;
            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
        } else {
            let storage = { neverAgain: true }
            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
        }
    } catch (e) {
        console.error(`Can't get access to localStorage`);
    }
}

export const getNeverAgain = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            if (storage.neverAgain != undefined && storage.neverAgain === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } catch (e) {
        console.error(`Can't get access to localStorage`);
        return false;
    }
}

const getIsTimeForTrigger = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            if (storage.lastTimeNotNow != undefined) {
                if (storage.lastTimeNotNow + storage.timeDelay < Date.now()) {
                    return true;
                }
            } else {
                return true;
            }

            return false;
        }
    } catch (e) {
        console.error(`Can't get access to localStorage`);
    }
}

export const addRateTriggerAction = (triggerAction = TRIGGER_ACTIONS.time, triggersCheck = false) => {
    try {
        if (triggersCheck) {
            actionTriggered()
        }
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            const triggerArray = storage.triggers || [];

            if (!triggerArray.includes(triggerAction)) {
                triggerArray.push(triggerAction);
                storage.triggers = triggerArray;

                localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
            }
        } else {
            let storage = { triggers: [] }
            storage.triggers = [triggerAction];
            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
        }
    } catch (e) {
        console.error(`Can't get access to localStorage or storage.triggers is not an array`);
    }
}

const startTimeCheckWithSettingsOpened = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            if (storage.timeStartSettings == undefined)
                storage.timeStartSettings = Date.now();
        } else {
            let storage = { timeStartSettings: Date.now() }
            localStorage.setItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`, JSON.stringify(storage));
        }
    } catch (e) {
        console.error(`Can't get access to localStorage or storage.triggers is not an array`);
    }
}

const getTimeWithSettingsOpened = () => {
    try {
        const storage = JSON.parse(localStorage.getItem(`${APP_NAME_STORAGE}-rate-us-triggered-actions`));
        if (storage != null) {
            return storage.timeStartSettings;
        } else {
            return 0;
        }
    } catch (e) {
        console.error(`Can't get access to localStorage or storage.triggers is not an array`);
    }
}


const firstTimeOnSessionNotOpen = () => {
    try {
        const storage = sessionStorage.getItem(`${APP_NAME_STORAGE}-rate-us-first-no-open`);
        if (storage === 'true') {
            return true;
        } else {
            sessionStorage.setItem(`${APP_NAME_STORAGE}-rate-us-first-no-open`, `true`);
            return false;
        }
    } catch (e) {
        console.error(`Can't get access to sessionStorage`);
        return false;
    }
}

const doesTriggersHaveSequence = () => {
    if (getNeverAgain()) {
        return false;
    }
    const currentActions = getCurrentTriggerActions();

    if (currentActions === null || currentActions === undefined)
        return false;

    for (let sequence of TRIGGER_SEQUENCES) {
        for (let action of currentActions) {
            if (sequence.includes(action)) {
                if (sequence.length === 1) {
                    return true;
                }
                let isAllActionsInSequence = true;
                for (let sequenceAction of sequence) {
                    if (!currentActions.includes(sequenceAction)) {
                        isAllActionsInSequence = false;
                        break;
                    }
                }

                if (isAllActionsInSequence === true) {
                    return true;
                }
            }
        }
    }

    return false;
}

const logCurrentActions = () => {
    if (getCurrentTriggerActions() != null) {
        for (let action of getCurrentTriggerActions()) {
            console.log(action)
        }
    } else {
        console.log("CurrentTriggerActions are NULL")
    }
}


export class SettingsRateLogicWatcher extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            active: false,
            triggered: false,
            tickInterval: {},
            timeSpentFromSettingsOpened: 0
        };
    }

    componentDidMount() {
        if (this.props.triggeredDontShow) {
            clearActionTrigger();
            return;
        }

        if (this.props.isLoaded) {
            this.activate()
            this.checkForTriggers()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.triggeredDontShow) {
            clearActionTrigger();
            return;
        }

        if (!prevProps.isLoaded && this.props.isLoaded && !this.state.active) {
            this.activate()
            this.checkForTriggers()
        }
    }

    activate() {
        // console.log('activate')
        this.setState({ active: true });
        let tickInterval = setInterval(() => { this.checkForTriggers() }, TICK_RATE)
        this.setState({ tickInterval: tickInterval })
        startTimeCheckWithSettingsOpened()
        actionTriggered()
    }

    checkForTriggers() {
        if (this.props.triggeredDontShow) {
            this.setState({ triggered: true })
            clearActionTrigger()
            clearInterval(this.state.tickInterval)
            return;
        }

        if (getTimeWithSettingsOpened() + TIME_LIMIT_FIRST_SHOW < Date.now()) {
            addRateTriggerAction(TRIGGER_ACTIONS.time)
        }
        const dTHS = doesTriggersHaveSequence()
        // console.log("checkForTriggers")
        // console.log("doesTriggersHaveSequence", dTHS)
        // console.log("!this.state.triggered", !this.state.triggered)
        // console.log("getIsTimeForTrigger", getIsTimeForTrigger())
        // console.log("isActionTriggered", isActionTriggered())

        if (dTHS && !this.state.triggered && getIsTimeForTrigger() && isActionTriggered()) {
            if (firstTimeOnSessionNotOpen()) {
                this.props.onTrigger()
                this.setState({ triggered: true })
                clearActionTrigger()
                clearInterval(this.state.tickInterval)
            }
        }

        clearActionTrigger()

    }


    render() {
        return (
            <div style={{ display: 'none' }}>
            </div>
        );
    }
}



export class WidgetRateLogicWatcher extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (this.props.viewMode == "preview") {
            sessionStorage.setItem(`${APP_NAME_STORAGE}-back-from-preview`, `preview`)
        } else if (this.props.viewMode == "editor") {
            if (sessionStorage.getItem(`${APP_NAME_STORAGE}-back-from-preview`) == 'preview') {
                addRateTriggerAction(TRIGGER_ACTIONS.backFromPreview);
                sessionStorage.removeItem(`${APP_NAME_STORAGE}-back-from-preview`)
            }
        }
    }


    render() {
        return (
            <div style={{ display: 'none' }}>
            </div>
        );
    }
}
